import {createMemoryHistory, createRouter} from 'vue-router';
import courier from "../components/courier/Courier.vue";
import courier_new from "../components/courier/new/CourierNew.vue";
import courier_new_create from "../components/courier/new/CourierNewCreate.vue";
import courier_new_info from "../components/courier/new/CourierNewInfo.vue";
import courier_new_menu from "../components/courier/new/CourierNewMenu.vue";
import locations_courier_list from "../components/courier/new/locations/LocationsCourierList.vue";

const routes = [
    {
        path: '/courier',
        name: 'courier',
        component: courier,
        props: true,
    },
    {
        path: '/new/courier/create',
        name: 'courierNewCreate',
        component: courier_new_create,
        props: true,
    },
    {
        path: '/new/menu',
        name: 'courierNewMenu',
        component: courier_new_menu,
        props: true,
    },
    {
        path: '/new',
        name: 'courierNew',
        component: courier_new,
        props: true,
    },
    {
        path: '/new/data',
        name: 'courierNewData',
        component: courier_new_info,
        props: true,
    },
    {
        path: '/new/locations',
        name: 'locations',
        component: locations_courier_list,
        props: true,
    },
    {
        path: '',
        redirect: '/courier'
    }
]

const couriers_router = createRouter({
    history: createMemoryHistory(),
    base: '/:lang/couriers',
    routes
});

export default couriers_router;

